import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { FormGroup } from '@angular/forms'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { AuthorizeService } from '../../service/authorize.service'
import { MatMenuTrigger } from '@angular/material';
import { ToastrService } from '../../../../node_modules/ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-analyze-executive-summary',
  templateUrl: './analyze-executive-summary.component.html',
  styleUrls: ['./analyze-executive-summary.component.scss']
})
export class AnalyzeExecutiveSummaryComponent implements OnInit {
  @Input() printPage
  @Input() isFullFactSheet
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  modalRef: BsModalRef
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }
  isAnalyzeExsum = true
  showTextWhenNull = '- Update Recent development, Investment Plan, News '
  showTextWhenNull2 = '- Analyze latest fin statement'
  showTextWhenNull3 = '- SWOT…'
  checkNulltext = false
  text
  newText
  symbol
  checkDis = false
  checkModified = false
  comId
  secproData
  secproReturn = []
  checkUpdate = false
  form: FormGroup
  file: File
  subscription: Subscription
  isAE
  message

  constructor(
    private cpmService: CpmService,
    private store: StoreService,
    private authorization: AuthorizeService,
    private toastr: ToastrService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
        this.text = response['analyze']
        this.comId = response['companyIdPsims']
        this.isAE = response['ae']
        this.onChangeData()
      })
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('COMPINFO_EDIT')
    )
  }

  async onChangeData() {
    this.newText = this.text
  }

  modifiedText() {
    return (this.checkModified = true)
  }
  checkDisplay() {
    return (this.checkDis = true)
  }

  checkCancel() {
    this.newText = this.text
    return (this.checkUpdate = false), (this.checkDis = false)
  }

  checkSubmit() {
    this.text = this.newText
    this.updateToSecprofile()
    return (this.checkUpdate = true), (this.checkDis = false)
  }

  async updateToSecprofile() {
    const body = {
      companyId: this.comId,
      fieldName: 'analyze',
      fieldValue: this.text
    }
    await this.cpmService.updateCompanyProfile(body).then(response => {
      this.message = response.status
      this.message === 'OK' ? (this.toastr.success('การบันทึกรายการสำเร็จแล้ว')) : (this.message = 'บันทึกรายการไม่สำเร็จ')
    },
      error => {
        this.message = 'บันทึกรายการไม่สำเร็จ'
        this.openModal(this.templateSaved)
      })
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }
  clickEditDropdown(event: Event) {
    $(event.target)
      .closest('div')
      .next()
      .toggleClass('show')
  }

  mourseLeaveMenu() {
    $(event.target)
      .find('#editItemListAnalyze')
      .removeClass('show')
  }
  closeModal() {
    this.modalRef.hide()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/analyze-executive-summary/analyze-executive-summary.component.ts